// extracted by mini-css-extract-plugin
export default {"not-found-container":"NotFound_not-found-container__WJ9h8"};